import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as2002',
    ecrans: ['00-2'],
    params: ['id',
        '?asgcleint',
        '?unpcleint']
});